var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 47,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6114 54.3778L77.8057 52.7416C77.124 51.3572 75.4504 50.7857 74.0643 51.4641V51.4641C73.4039 51.7972 72.6381 51.854 71.9357 51.6218C71.2334 51.3897 70.6522 50.8877 70.3204 50.2266C70.1066 49.8062 70.0076 49.3368 70.0335 48.8659V48.8659C70.1044 48.1128 69.8675 47.363 69.3767 46.7874C68.8859 46.2118 68.183 45.8594 67.4281 45.8105L65.5974 45.691C64.8579 45.6427 64.1296 45.8911 63.5738 46.3812C63.0179 46.8713 62.6803 47.5627 62.6355 48.3024V48.3024C62.514 49.8278 61.1899 50.9727 59.663 50.8729C59.1927 50.8373 58.7401 50.6781 58.3511 50.4115V50.4115C57.065 49.5587 55.3313 49.9078 54.4754 51.1919L53.3952 52.7318C52.5404 54.0142 52.8833 55.7464 54.1622 56.6065V56.6065C54.9938 57.1618 55.4659 58.1186 55.4008 59.1164C55.3357 60.1142 54.7432 61.0015 53.8465 61.444V61.444C52.4686 62.1254 51.9032 63.7942 52.5831 65.1728V65.1728L53.4014 66.8232C53.7191 67.4966 54.2922 68.0157 54.9937 68.2655C55.6952 68.5153 56.4673 68.4753 57.1392 68.1542V68.1542C57.8007 67.824 58.5666 67.7717 59.2668 68.0089C59.9671 68.2462 60.5435 68.7533 60.868 69.4176C61.0818 69.838 61.1808 70.3074 61.155 70.7783V70.7783C61.0543 72.3208 62.2231 73.6528 63.7655 73.7535L65.5963 73.873C67.1335 73.9734 68.4629 72.8126 68.5706 71.2758V71.2758C68.6155 70.5337 68.9551 69.8404 69.5139 69.3501C70.0726 68.8598 70.8042 68.6132 71.5458 68.6652C72.0145 68.7084 72.4652 68.8669 72.8577 69.1266V69.1266C74.1402 69.9814 75.8724 69.6385 76.7325 68.3596V68.3596L77.7993 66.8188C78.2134 66.2039 78.3654 65.4493 78.2214 64.722C78.0774 63.9947 77.6495 63.3548 77.0323 62.9441V62.9441C76.4151 62.5333 75.9872 61.8934 75.8432 61.1661C75.6993 60.4389 75.8512 59.6842 76.2653 59.0693C76.5351 58.6623 76.9086 58.3346 77.3472 58.12V58.12C78.7191 57.4333 79.2826 55.7703 78.6105 54.3912V54.3912L78.6114 54.3778Z",
    stroke: "#4F449B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.6035,
    cy: 59.7824,
    rx: 3.85677,
    ry: 3.85677,
    transform: "rotate(3.73482 65.6035 59.7824)",
    stroke: "#4F449B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0503 18.431H36.7708C35.8894 18.431 35.1748 19.1456 35.1748 20.0271V20.8251C35.1748 23.205 37.1041 25.1344 39.4841 25.1344H49.8583C52.5027 25.1344 54.6464 22.9907 54.6464 20.3463V20.0271C54.6464 19.1456 53.9318 18.431 53.0503 18.431Z",
    fill: "#4F449B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4602 21.7827H25.1185C24.237 21.7827 23.5225 22.4973 23.5225 23.3787V78.4417C23.5225 79.3232 24.237 80.0378 25.1185 80.0378H63.7424C64.6238 80.0378 65.3384 79.3232 65.3384 78.4417V77.1649M57.3583 21.7827H63.7424C64.6239 21.7827 65.3384 22.4973 65.3384 23.3787V42.5311",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7881 34.7105L32.1387 38.0611C32.3184 38.2407 32.6071 38.2488 32.7965 38.0793L38.5239 32.9548",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6299 56.4164L31.9805 59.767C32.1602 59.9467 32.4489 59.9547 32.6383 59.7852L38.3657 54.6608",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6299 46.0423L31.9805 49.3928C32.1602 49.5725 32.4489 49.5805 32.6383 49.4111L38.3657 44.2866",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 67.5888L31.8203 70.9393C32 71.119 32.2888 71.1271 32.4781 70.9576L38.2055 65.8331",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 37.7429H60.7105",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 48.5959H52.5708",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 59.4489H48.1019",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 70.3019H51.2939",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9877,
    cy: 18.3512,
    r: 3.13908,
    stroke: "#4F449B",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartMatch);
export default __webpack_public_path__ + "static/media/smartMatch.fc679f42eb5d058e5e312e1a0da6f610.svg";
export { ForwardRef as ReactComponent };